"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissionsService = void 0;
var OpenAPI_1 = require("../core/OpenAPI");
var request_1 = require("../core/request");
var MissionsService = /** @class */ (function () {
    function MissionsService() {
    }
    /**
     * Get Recommended Missions
     * Get recommended missions for the calling user (v1 and v2)
     * @param next
     * @param limit
     * @param weeklyHoursAvailable
     * @param availabilityDate
     * @returns DictQueryResponse_MissionRecommendation_ Success
     * @throws ApiError
     */
    MissionsService.getRecommendedMissions = function (next, limit, weeklyHoursAvailable, availabilityDate) {
        if (limit === void 0) { limit = 20; }
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/missions',
            query: {
                'next': next,
                'limit': limit,
                'weeklyHoursAvailable': weeklyHoursAvailable,
                'availabilityDate': availabilityDate,
            },
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Get Mission Recommendation
     * Determine the recommended roles for a given mission
     * @param mid The mission id
     * @returns team_graph__models__missions__recommendations__MissionRecommendation Success
     * @throws ApiError
     */
    MissionsService.getMissionRecommendation = function (mid) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/missions/{mid}',
            path: {
                'mid': mid,
            },
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Estimated Applications Count
     * Get estimated number of applications from a reach-out to
     * the list of given users about the given role
     * @param requestBody
     * @returns ApplicationEstimationTargetResponseModel Success
     * @throws ApiError
     */
    MissionsService.estimatedApplicationsCount = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/missions/application-estimations/count',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Minimal List Of Builders
     * Get estimated number of applications from a reach-out to
     * the list of given users about the given role
     * @param requestBody
     * @returns ApplicationEstimationTargetResponseModel Success
     * @throws ApiError
     */
    MissionsService.minimalListOfBuilders = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/missions/application-estimations/target',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Get Recommended Missions Per User
     * Get recommended missions for the given user (v1 and v2)
     * @param uid The user id
     * @param next
     * @param limit
     * @param weeklyHoursAvailable
     * @param availabilityDate
     * @returns DictQueryResponse_MissionRecommendation_ Success
     * @throws ApiError
     */
    MissionsService.getRecommendedMissionsPerUser = function (uid, next, limit, weeklyHoursAvailable, availabilityDate) {
        if (limit === void 0) { limit = 20; }
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/missions/users/{uid}',
            path: {
                'uid': uid,
            },
            query: {
                'next': next,
                'limit': limit,
                'weeklyHoursAvailable': weeklyHoursAvailable,
                'availabilityDate': availabilityDate,
            },
            errors: {
                422: "Validation Error",
            },
        });
    };
    return MissionsService;
}());
exports.MissionsService = MissionsService;
//# sourceMappingURL=MissionsService.js.map